import React, { useContext } from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import { HubContext } from "scenes/Hubly/components/Workspace/Provider";

import MergeContactSelector from "../../MergeContactSelector";

export function MergeButton({ client }) {
  const { viewClientCard } = useContext(HubContext);

  return (
    <MergeContactSelector
      sourceClient={client}
      onSuccess={({ id }) => {
        viewClientCard(id);
      }}
    >
      <Button primary size="small" data-dd-action-name="Merge Selector">
        Merge
      </Button>
    </MergeContactSelector>
  );
}

MergeButton.propTypes = {
  client: PropTypes.object.isRequired,
};

MergeButton.defaultProps = {};

export default MergeButton;
